module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/btn_pc_4e7384d04be0e1cd945e1e77edd794ee.png";